import React, { useCallback } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { IssueOperationsCacheProvider } from '@atlassian/jira-issue-navigator-issue-operations-services/src/services/utils/state-cache.tsx';
import { ErrorFlagRenderer } from '@atlassian/jira-error-boundary-flag-renderer/src/ErrorBoundaryFlag.tsx';
import { DropdownTrigger } from '@atlassian/entry-point-dropdown';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { PropsProvider, type Props } from '../controllers/props-context/index.tsx';
import { meatballMenuEntrypoint } from './entrypoint.tsx';
import { Trigger } from './trigger/index.tsx';
import messages from './messages.tsx';

const errorBoundaryId = 'issue-operations-entrypoint';

export const MeatballMenu = (props: Props) => {
	const { formatMessage } = useIntl();

	const { createAnalyticsEvent } = useAnalyticsEvents();
	const onClick = useCallback(() => {
		const analyticsEvent = createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'dropdownMenu',
		});
		fireUIAnalytics(analyticsEvent, 'issueOperationsMeatballMenu');
	}, [createAnalyticsEvent]);

	return (
		<JSErrorBoundary
			id={errorBoundaryId}
			packageName="jiraIssueNavigatorIssueOperations"
			teamName="empanada"
			fallback={({ error }) => (
				<>
					<Trigger
						label={formatMessage(messages.menuButtonLabel, { issueKey: props.issueKey })}
						isDisabled
					/>
					<ErrorFlagRenderer id={errorBoundaryId} error={error} />
				</>
			)}
		>
			<PropsProvider {...props}>
				<IssueOperationsCacheProvider>
					<DropdownTrigger
						entryPoint={meatballMenuEntrypoint}
						errorFallback={({ error }) => {
							// Throw error back up the stack to be caught and logged by the JSErrorBoundary
							throw error;
						}}
						trigger={(triggerProps) => (
							<Trigger
								issueId={props.issueId.toString()}
								label={formatMessage(messages.menuButtonLabel, { issueKey: props.issueKey })}
								{...triggerProps}
								onClick={(...onClickProps) => {
									onClick();
									triggerProps.onClick?.(...onClickProps);
								}}
							/>
						)}
						placement="bottom-end"
						shouldRenderToParent
					/>
				</IssueOperationsCacheProvider>
			</PropsProvider>
		</JSErrorBoundary>
	);
};

export default MeatballMenu;
